/* Add the resolved product selection, then review Shopify's native cart. */
(() => {
  const bar = document.getElementById('sb-fixed-buy');
  if (!bar || bar.dataset.initialized) return;
  bar.dataset.initialized = 'true';
  const button = bar.querySelector('button');
  const selection = bar.querySelector('[data-sb-selection]');
  const price = bar.querySelector('[data-sb-price]');
  const error = bar.querySelector('[role="alert"]');
  let main, observer, busy = false, added = false;
  const sourceForm = () => main?.querySelector('product-form form');
  const sourceButton = () => sourceForm()?.querySelector('[name="add"]');
  const showError = message => {
    error.textContent = message || '';
    error.hidden = !message;
  };
  function sync() {
    const form = sourceForm();
    const add = sourceButton();
    if (!form || !add) return;
    bar.hidden = false;
    document.body.classList.add('sb-has-fixed-buy');
    const state = main.dataset.sbSelectionState;
    const checked = Array.from(main.querySelectorAll('variant-selects input:checked, variant-selects select option:checked'));
    selection.textContent = checked.length ? checked.map(x => x.value).join(' / ') : main.querySelector('h1')?.textContent.trim();
    const priceRoot = main.querySelector('[id^="price-"] .price');
    const amount = priceRoot?.querySelector(priceRoot.classList.contains('price--on-sale') ? '.price-item--sale' : '.price__regular .price-item--regular');
    price.textContent = amount?.textContent.trim() || '';
    const waiting = state === 'loading';
    const failed = state === 'error';
    button.disabled = busy || waiting || (!failed && (add.disabled || add.getAttribute('aria-disabled') === 'true' || !form.elements.id?.value));
    button.textContent = busy ? bar.dataset.cartLabel : waiting ? bar.dataset.loadingLabel : failed ? bar.dataset.retryLabel : button.disabled ? add.querySelector('span')?.textContent.trim() || bar.dataset.unavailableLabel : bar.dataset.buyLabel;
    if (waiting) { price.textContent = ''; showError(''); }
    if (failed) { price.textContent = ''; showError(bar.dataset.errorLabel); }
  }
  function bind() {
    const next = document.querySelector('product-info[id^="MainProduct-"]');
    if (!next || next === main) return;
    observer?.disconnect();
    main = next;
    observer = new MutationObserver(sync);
    observer.observe(main, {subtree:true, childList:true, attributes:true, attributeFilter:['disabled','aria-disabled','data-sb-selection-state']});
    sync();
  }
  document.addEventListener('product-info:loaded', bind);
  // The theme emits this before resolving an asynchronously selected variant.
  document.addEventListener('change', event => {
    if (main?.contains(event.target)) sync();
  });
  window.addEventListener('pageshow', () => { busy = false; added = false; bind(); sync(); });
  button.addEventListener('click', async () => {
    if (busy || button.disabled) return;
    if (main.dataset.sbSelectionState === 'error') {
      const option = main.querySelector('variant-selects input:checked, variant-selects select');
      option?.dispatchEvent(new Event('change', {bubbles:true}));
      return;
    }
    const form = sourceForm();
    if (!form?.reportValidity()) return;
    // Serialize synchronously, before any subsequent color/size change.
    const data = new FormData(form);
    if (!data.get('id') || sourceButton()?.disabled) return;
    data.delete('sections');
    data.delete('sections_url');
    showError(''); busy = true; sync();
    try {
      if (!added) {
        const response = await fetch(bar.dataset.addUrl, {method:'POST', headers:{Accept:'application/json'}, body:data});
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : bar.dataset.cartErrorLabel);
        added = true;
      }
      // Let the customer review quantities and remove items before native checkout.
      window.location.assign(bar.dataset.cartUrl);
    } catch (err) {
      busy = false;
      showError(err.message || bar.dataset.cartErrorLabel);
      sync();
    }
  });
  new ResizeObserver(() => document.body.style.setProperty('--sb-buy-height', `${bar.getBoundingClientRect().height}px`)).observe(bar);
  // Keep Shopify Forms' small offer teaser above the bar; leave its full dialog alone.
  function moveOfferTeaser(host) {
    const root = host.shadowRoot;
    if (!root || root.querySelector('[data-sb-buy-offset]')) return;
    const style = document.createElement('style');
    style.dataset.sbBuyOffset = 'true';
    style.textContent = '#app-embed[data-current-step="tease"][data-position^="bottom"] { bottom: calc(var(--sb-buy-height, 100px) + 10px) !important; }';
    root.appendChild(style);
  }
  function findOfferTeasers() { document.querySelectorAll('shopify-forms-embed').forEach(moveOfferTeaser); }
  window.customElements?.whenDefined('shopify-forms-embed').then(findOfferTeasers);
  new MutationObserver(records => {
    for (const record of records) for (const node of record.addedNodes) {
      if (node.nodeType !== 1) continue;
      if (node.matches('shopify-forms-embed')) moveOfferTeaser(node);
      node.querySelectorAll('shopify-forms-embed').forEach(moveOfferTeaser);
    }
  }).observe(document.body, { childList:true, subtree:true });
  findOfferTeasers();
  bind();
})();
